(function ($) {
  $(function () {
    var lottie = $("lottie-player");

    if (!lottie.length) {
      return;
    }

    LottieInteractivity.create({
      player: ".js-purposes-animation",
      mode: "scroll",
      actions: [
        {
          visibility: [0.1, 1],
          type: "seek",
          frames: [0, 290],
        },
      ],
    });

    LottieInteractivity.create({
      player: ".js-purposes-animation-mobile",
      mode: "scroll",
      actions: [
        {
          visibility: [0.1, 1],
          type: "seek",
          frames: [0, 230],
        },
      ],
    });
  });
})(jQuery);
